import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../../shared/translate/translate.service';
import { IKeyValueInterface } from '../../shared/config';
import { AuthService } from '../../shared/models/auth.service';
import { PersonService } from '../../person/models/person.service';
import { InvitePersonModel } from '../../admin-invite-popup/models/admin-to-invite.model';

@Component({
  selector: 'wego-invite-driver-popup',
  template: require('../views/invite-driver-popup.component.html'),
  providers: []
})

export class InviteDriverPopupComponent implements OnInit, OnDestroy {
  email: string;
  public availablePersons: InvitePersonModel[] = [];
  ErrorMsg: string = '';
  userName : string='';
  errorModel: IKeyValueInterface[] = [];
  _popupTitle: string = this.translate.instant('LblInvite');
  personHashId: string = "";
  public organizationHashId: string;
  rfidTagId : string;

  @ViewChild('InviteDriverModal') public InviteDriverModal: ModalDirective;

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim());
  }
  get popupTitle() { return this._popupTitle; }

  @Output('onConfirm') onConfirm = new EventEmitter();
  @Output('onCancel') onCancel = new EventEmitter();
  @Output('onEmailSearch') onEmailSearch = new EventEmitter();
  public fixRfidMsg: string;

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private personService: PersonService) {
  }

  ngOnInit() {
  }

  public show() {
    this.ErrorMsg = "";
    this.errorModel = [];
    this.personHashId = "";
    this.email = "";
    this.availablePersons = [];
    this.InviteDriverModal.show();
  }

  public hide() {
    this.InviteDriverModal.hide();
  }

  public OnchangeCreateNew()
  {
    if(this.personHashId == '0')
    {
      this.userName = '';
      this.errorModel = [];
      this.availablePersons = [];
      this.rfidTagId = null;
    }
  }

  private Confirm($event: any) {
    this.onConfirm.emit({
      emailAddress: this.email,
      personHashId: this.personHashId,
      UserName: this.userName,
      roleHashIdList: [],
      rfidTagId: this.rfidTagId
    });
  }

  private Reject($event: any) {
    this.hide();
    this.onCancel.emit($event);
  }

  public SearchUsers() {
    this.personHashId = '';
    this.errorModel = [];
    this.onEmailSearch.emit({ emailAddress: this.email });
  }

  public EmailAddressChange() {
    this.personHashId = "";
    this.availablePersons = [];
    this.rfidTagId = null;
  }

  ngOnDestroy() {
  }

  fixRfid() {
    if (this.rfidTagId) {
      var tag = this.rfidTagId.toUpperCase();
      this.CorrectTag(tag);
    }
  }  

  public CorrectTag(rfidTagId: string) {
    this.personService.CorrectTag(rfidTagId)
      .subscribe(
        res => {
          this.fixRfidMsg = "";
          if (res.data && !res.error) {            
            this.rfidTagId = res.data;
          }
          else {
            this.fixRfidMsg = res.error[0].value;
          }
        },
        error => {
          this.fixRfidMsg = this.authService.HandleErrorStatusCode(error);
        }
      );  
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationdriver/components/invite-driver-popup.component.ts